/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as ContactUsIcon } from "cms/assets/icons/message-dots.svg";

const ContactUsLink = () => {

    return (
        <Link to='#' title='Contact Us'>
            <ContactUsIcon alt='contact-us-icon' />
            Contact Us
        </Link>
    );
};

export { ContactUsLink };
